import styled, { css } from "styled-components";

import { DESKTOP_BREAKPOINT } from "../AppShell/styles";
import { PageTitle } from "../PageTitle";

type ContainerProps = {
  $desktopRoot: boolean;
  $empty: boolean;
  $hideOnMobile?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  border-bottom: 1px solid var(--color-neutral-dark);

  padding: 1.25rem 2rem;

  @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
    padding: 20px;
    ${props => props.$hideOnMobile && "display: none;"}
  }

  /* On desktop, screens reachable from the sidebar don't need a back button */
  ${props =>
    props.$desktopRoot &&
    css`
      @media (min-width: ${DESKTOP_BREAKPOINT}) {
        display: ${props.$empty ? "none" : "flex"};

        .back {
          display: none;
        }
      }
    `}
`;

/* Screen title, left-aligned after the back button; the right element (if any) is pushed to the end */
export const TitleSection = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled(PageTitle)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* Keeps the longest titles (e.g. "Perguntas e Respostas") on one line on phones */
  @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
    font-size: 22px;
    line-height: 28px;
  }
`;
